export enum EventTypes {
    ButtonClickImpression = "button-click",
    ButtonImpression = "button-impression",
    PageImpression = "page-impression",
    SectionImpression = "section-impression",
    ProductDetailImpression = "product-detail-impression",
    ProductImpression = "product-impression",
    ListImpression = "list-impression",
    SearchFilterImpression = "search-filter-impression",
    ProductClickImpression = "product-click",
    CartImpression = "cart-view",
    AddToCartImpression = "add-to-cart",
    RemoveFromCartImpression = "remove-from-cart",
    AddToWishlistImpression = "add-to-wishlist",
    ToolStep = "tool-step",
    ToolStepSubmit = "tool-laststep",
    BannerImpression = "banner-impression",
    BannerClickImpression = "banner-click",
    Lead = "lead",
    NavigationClick = "navigation-click",
    LinkClick = "link-click",
    NONE = "",
}
